import { required } from "vuelidate/lib/validators";

export default class FaturamentoData {
  forma_pagamento = null;
  valor = null;
  conta = null;
  plano_conta = null;
  vencimento = null;
  subtotal = 0;
  pagamentos = [];
  informacoes_complementares = "";
  constructor(
    forma_pagamento = null,
    valor = 0,
    conta = null,
    plano_conta = null,
    vencimento = null,
    subtotal = 0,
    pagamentos = [],
    informacoes_complementares = ""
  ) {
    this.forma_pagamento = forma_pagamento;
    this.valor = valor;
    this.conta = conta;
    this.plano_conta = plano_conta;
    this.vencimento = vencimento;
    this.subtotal = subtotal;
    this.pagamentos = pagamentos;
    this.informacoes_complementares = informacoes_complementares;
  }
}

export const FaturamentoDataRequired = {
  pagamentos: {
    required
  }
};
